// Visitor state for the back/forward cache (all sites, asked by jument). Plain module, no React, so the
// isomorphic graphql helper can use it; every function is a no-op on the server.
//
// A page restored from the bfcache shows the login, cart and data of the moment it was left. Whether that
// snapshot can still be trusted is decided by comparing `visitor_state_snapshot()` taken on `pagehide` with
// the one on `pageshow` (`bfcache_restore_action` in `@core/helpers/bfcache-rules`).
import { get_cookie_client } from "@core/helpers/client/cookie";

const VERSION_KEY = "_bt_visitor_state";

const in_browser = () => typeof window !== "undefined";

// Bumped after every successful mutation (cart, favorite, address, comment, order...). It lives in
// localStorage, so a change made in another tab is seen too.
export const mark_visitor_state_changed = () => {
	if (!in_browser()) return;
	try {
		window.localStorage.setItem(VERSION_KEY, `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`);
	} catch (e) { }
};

const read_version = () => {
	try {
		return window.localStorage.getItem(VERSION_KEY) || "";
	} catch (e) {
		return "";
	}
};

// Set right before this page sends the visitor away for good (bank gateway, payment result): when Back
// brings it back from the bfcache, it is reloaded instead (the order or wallet changed meanwhile).
let reload_on_restore = false;

export const reload_on_next_restore = () => {
	reload_on_restore = true;
};

export const visitor_state_snapshot = () => {
	if (!in_browser()) return {};
	return {
		token: get_cookie_client("_token") || "",
		locale: get_cookie_client("locale") || "",
		local_cart: get_cookie_client("local-cart") || "",
		version: read_version(),
		must_reload: reload_on_restore,
	};
};
